<template>
  <CModal :title="title" :color="color" size="lg" :show.sync="showModal">
    <CForm id="challenge_form" method="POST" enctype="multipart/form-data">
      <CRow style="padding-top: 10px">
        <CCol md="2">
          <div class="form-group">
            <label>Folio:</label>
            <p class="form-control-plaintext"> <strong>{{ form.code }}</strong></p>
          </div>
        </CCol>
        <CCol md="7">
          <CInput label="Nombre:" type="text" name="name" :lazy="false" :value.sync="$v.form.name.$model"
            :isValid="checkIfValid('name')" placeholder="" autocomplete="given-name"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
        <CCol md="3">
          <CSelect label="Proveedor: " :value.sync="$v.form.provider_id.$model" :options="providersOptions"
            :isValid="checkIfValid('provider_id')" invalidFeedback="Este campo es requerido." />
        </CCol>
      </CRow>
      <CRow>
        <CCol md="3">
          <CSelect label="Tipo" id="type" name="type" :value.sync="$v.form.type.$model" :options="typeOptions" />
        </CCol>
        <CCol md="9">
          <CInput label="Descripción:" type="text" name="description" :lazy="false"
            :value.sync="$v.form.description.$model" :isValid="checkIfValid('description')" placeholder=""
            autocomplete="given-description"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
      </CRow>
      <CRow v-if="form.type == 'boxes' || form.type == 'customers' || form.type == 'sales'">
        <CCol md="12">
          <CSelect v-if="form.type == 'boxes'" label="Mécanica del Concurso" id="mechanic" name="mechanic"
            :value.sync="$v.form.mechanic.$model" :options="mechanicBoxesOptions" />
          <CSelect v-if="form.type == 'customers'" label="Mécanica del Concurso" id="mechanic" name="mechanic"
            :value.sync="$v.form.mechanic.$model" :options="mechanicCustomersOptions" />
          <CSelect v-if="form.type == 'sales'" label="Mécanica del Concurso" id="mechanic" name="mechanic"
            :value.sync="$v.form.mechanic.$model" :options="mechanicSalesOptions" />
        </CCol>
      </CRow>
      <CRow v-if="form.type == 'video'">
        <CCol :md="form.mechanic == 'continuous' ? 8 : 12">
          <CSelect label="Mécanica del Concurso" id="mechanic" name="mechanic" :value.sync="$v.form.mechanic.$model"
            :options="mechanicVideoOptions" />
        </CCol>
        <CCol md="4" v-if="form.mechanic == 'continuous'">
          <CInput label="Cantidad de Cierre:" type="text" name="max_uploads" :lazy="false"
            :value.sync="$v.form.max_uploads.$model" :isValid="checkIfValid('max_uploads')" placeholder=""
            autocomplete="given-max_uploads"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
      </CRow>
      <CRow>
        <CCol :md="form.type == 'video' ? 8 : 12">
          <CInput type="file" name="image" id="image" label="Imagen del concurso:" :lazy="false"
            :value.sync="$v.form.image.$model" />
        </CCol>
        <CCol md="4" v-if="form.type == 'video'">
          <CInput label="Texto del Botón:" type="text" name="text_button" :lazy="false"
            :value.sync="$v.form.text_button.$model" :isValid="checkIfValid('text_button')" placeholder=""
            autocomplete="given-text_button"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
      </CRow>
      <CRow v-if="form.type == 'video' && form.id == 0">
        <CCol md="12">
          <CInput label="Link de Youtube:" type="youtube" name="youtube" :lazy="false"
            :value.sync="$v.form.youtube.$model" :isValid="checkIfValid('youtube')" placeholder=""
            autocomplete="given-youtube" invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
      </CRow>
      <CRow>
        <CCol :md="6">
          <div role="group" class="form-group" style="margin: -10px 0px 10px">
            <label style="padding-top: 10px;">Inicio de la Promoción:</label>
            <v-date-picker class="date-picker" v-model="$v.form.start_date.$model" :isValid="checkIfValid('start_date')"
              locale="es-MX" size="sm" :popover="{ visibility: 'click' }" />
          </div>
        </CCol>
        <CCol :md="6">
          <div role="group" class="form-group" style="margin: -10px 0px 10px">
            <label style="padding-top: 10px;">Fin de la Promoción:</label>
            <v-date-picker class="date-picker" v-model="$v.form.end_date.$model" :isValid="checkIfValid('end_date')"
              locale="es-MX" size="sm" :popover="{ visibility: 'click' }" />
          </div>
        </CCol>
      </CRow>
    </CForm>
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="store" :color="color">Aceptar</CButton>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, numeric, minLength, helpers, requiredIf, requiredUnless, minValue } from "vuelidate/lib/validators"
import { DatePicker } from 'v-calendar'

import moment from 'moment';
import moment_timezone from 'moment-timezone';

import c from 'moment-timezone';
import ws from '../../services/challenges';
import providers_ws from '../../services/providers';
import store from '../../store'

export default {
  name: 'ChallengeModal',
  components: { 'v-date-picker': DatePicker },
  data() {
    return {
      showModal: false,
      title: "Nuevo Concurso",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      fields: [
        { key: 'name', label: 'Nombre' },
        { key: 'actions', label: '', class: 'actions' }
      ],
      typeOptions: [
        { label: 'Objetivos', value: 'objectives' },
        { label: 'Capacitación', value: 'video' },
        { label: 'Venta Mínima', value: 'sales' },
        { label: 'Clientes Mínimos', value: 'customers' },
        { label: 'Mínimo de Cajas', value: 'boxes' },
        { label: 'Cajas & Clientes', value: 'boxes_and_customers' }
      ],
      mechanicBoxesOptions: [
        { label: 'Numero Total de Cajas Vendidas', value: 'total' },
        { label: 'Rangos de Cajas Vendidas', value: 'ranges' },
        { label: 'Individual por cada Caja Vendida', value: 'individual' }
      ],
      mechanicSalesOptions: [
        { label: 'Total de Ventas', value: 'total' },
        { label: 'Rangos de Ventas', value: 'ranges' },
        { label: 'Individual por cada Monto de Ventas', value: 'individual' }
      ],
      mechanicCustomersOptions: [
        { label: 'Numero Total de Clientes', value: 'total' },
        { label: 'Rangos de Clientes', value: 'ranges' },
        { label: 'Individual por cada Cliente', value: 'individual' }
      ],
      mechanicVideoOptions: [
        { label: 'Individual', value: 'normal' },
        { label: 'Multiple', value: 'continuous' },
      ],
      link: '',
      item: false,
      providers: [],
      providersOptions: []
    }
  },
  mounted: async function () {
    let response = await providers_ws.get();

    if (response.type == "success") {
      this.providers = response.data;
      this.providersOptions = await this.$parseSelectOptionsOrdered(this.providers, "id", "name", [{ value: '0', label: 'NO DEFINIDO' }]);
    }
  },
  methods: {
    async storeModal() {
      this.showModal = true;
      this.color = "info";
      this.title = 'Nuevo Concurso';
      this.isEdit = false;
      this.submitted = false;

      this.form = {
        id: 0,
        provider_id: 0,
        code: '',
        name: '',
        description: '',
        text_button: 'Iniciar Cuestionario',
        image: null,
        type: 'video',
        mechanic: 'total',
        youtube: '',
        points: '',
        max_uploads: 1,
        start_date: new moment_timezone().tz("America/Mexico_city").startOf('month').toDate(),
        end_date: new moment_timezone().tz("America/Mexico_city").endOf("month").toDate()
      }
      let response = await ws.nextCodeChallenge();
      if (response.type == "success") {
        this.form.code = response.data;
      }
    },
    updateModal(item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Concurso';
      this.isEdit = true;
      this.submitted = false;

      this.item = item;

      this.form = {
        id: item.id,
        code: item.code,
        code: item.code,
        name: item.name,
        description: item.description,
        text_button: item.text_button,
        type: item.type,
        mechanic: item.mechanic,
        points: item.points,
        max_uploads: item.max_uploads,
        start_date: new moment_timezone(item.start_date, "YYYY-MM-DD").tz("America/Mexico_city").toDate(),
        end_date: new moment_timezone(item.end_date, "YYYY-MM-DD").tz("America/Mexico_city").toDate(),
        youtube: item.youtube,
        provider_id: item.provider_id
      };
    },
    store() {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        this.form.start_date = new moment_timezone(this.form.start_date).format("YYYY-MM-DD");
        this.form.end_date = new moment_timezone(this.form.end_date).format("YYYY-MM-DD");

        const form = document.getElementById("challenge_form");
        const formData = new FormData(form);

        formData.append("id", this.form.id);
        formData.append("provider_id", this.form.provider_id);
        formData.append("start_date", new moment_timezone(this.form.start_date).format("YYYY-MM-DD"));
        formData.append("end_date", new moment_timezone(this.form.end_date).format("YYYY-MM-DD"));
        formData.append("code", this.form.code);

        if (this.form.id > 0) {
          this.$emit("update", formData);
        }
        else {
          this.$emit("store", formData);
        }

        this.closeModal();
      }
    },
    closeModal() {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm() {
      return {
        id: 0,
        code: '',
        name: '',
        description: '',
        text_button: '',
        type: 'video',
        mechanic: 'total',
        image: null,
        youtube: '',
        points: 0,
        max_uploads: 1,
        start_date: new moment_timezone().tz("America/Mexico_city").startOf('month').toDate(),
        end_date: new moment_timezone().tz("America/Mexico_city").endOf("month").toDate()
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }

      return !(field.$invalid || field.$model === '')
    },
    redirectLink(link) {
      window.location = link;
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    },
  },
  computed: {
    formString() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$invalid },
    isDirty() { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      provider_id: {
        required,
        minValue: minValue(1)
      },
      name: {
        required,
        minLength: minLength(3)
      },
      description: {
        required,
        minLength: minLength(3)
      },
      text_button: {
        required: requiredIf(function (form) {
          return form.type == 'video'
        }),
        minLength: minLength(3)
      },
      max_uploads: {
        required: requiredIf(function (form) {
          return form.type == 'video' && form.mechanic == 'continuous'
        }),
        numeric,
        minValue: minValue(1)
      },
      code: {},
      type: {
        required
      },
      mechanic: {
        required: requiredIf(function (form) {
          return form.type == 'boxes' && form.id == 0
        })
      },
      youtube: {
      },
      points: {

      },
      start_date: {

      },
      end_date: {

      },
      image: {

      }
    }
  },
}
</script>